/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetSearchParams,
  HangarSearchParams,
  SchemaValidationErrorResponse,
  SearchParams,
  SearchResults,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Search one fleet
 */
export const fleetSearch = (
    fleetSlug: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<FleetSearchParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<SearchResults>(
      {url: `/fleets/${fleetSlug}/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetSearchQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSearchParams>,) => {
    return [
    'fleets',fleetSlug,'search', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetSearchQueryOptions = <TData = Awaited<ReturnType<typeof fleetSearch>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<FleetSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetSearchQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetSearch>>> = ({ signal }) => fleetSearch(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetSearch>>, TError, TData>
}

export type FleetSearchQueryResult = NonNullable<Awaited<ReturnType<typeof fleetSearch>>>
export type FleetSearchQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Search one fleet
 */

export function useFleetSearch<TData = Awaited<ReturnType<typeof fleetSearch>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<FleetSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetSearchQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search the current user's hangar
 */
export const hangarSearch = (
    params: MaybeRefOrGetter<HangarSearchParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SearchResults>(
      {url: `/hangar/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarSearchQueryKey = (params?: MaybeRefOrGetter<HangarSearchParams>,) => {
    return [
    'hangar','search', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarSearchQueryOptions = <TData = Awaited<ReturnType<typeof hangarSearch>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params: MaybeRefOrGetter<HangarSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarSearch>>> = ({ signal }) => hangarSearch(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarSearch>>, TError, TData>
}

export type HangarSearchQueryResult = NonNullable<Awaited<ReturnType<typeof hangarSearch>>>
export type HangarSearchQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Search the current user's hangar
 */

export function useHangarSearch<TData = Awaited<ReturnType<typeof hangarSearch>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params: MaybeRefOrGetter<HangarSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search the catalogues
 */
export const search = (
    params: MaybeRefOrGetter<SearchParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SearchResults>(
      {url: `/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchQueryKey = (params?: MaybeRefOrGetter<SearchParams>,) => {
    return [
    'search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchQueryOptions = <TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<SchemaValidationErrorResponse>>(params: MaybeRefOrGetter<SearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({ signal }) => search(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>
}

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>
export type SearchQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search the catalogues
 */

export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params: MaybeRefOrGetter<SearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






